import React from "react";
import cx from "classnames";
import { useDrop } from "react-dnd";
import { MenuItem } from "@showitinc/showit-wc";

import ContextMenuWrapper from "../../app2components/ContextMenus/ContextMenuWrapper";
import AssetActions from "../../actions/AssetActions";
import AssetLibraryStore from "../../stores/AssetLibraryStore";
import { generateDropSpec } from "../../utils/DnDUtils";
import { ASSET_ITEM } from "../../constants/DnDConstants";
import uiPrefix from "../../utils/UiPrefixUtils";

const AssetFolder = ({
  enableContextMenu,
  active,
  name,
  onClick,
  onRename,
  onDelete,
  folder,
  allowFolderDrops = false,
}) => {
  const drop = generateDropSpec({
    type: ASSET_ITEM,
    canDrop: () => allowFolderDrops,
    onDrop: (dragItem) => {
      // Get all selected assets from the store, or just the dragged asset if none are selected
      const selected = AssetLibraryStore.state.assets.filter(
        (asset) => asset.selected
      );

      // If there are selected assets, move all of them. Otherwise, just move the dragged asset
      const assetsToMove = selected.length > 0 ? selected : [dragItem.asset];
      AssetActions.moveToFolder(assetsToMove, folder);
    },
  });

  const [{ isOver }, dropRef] = useDrop(drop);

  const topClasses = cx({
    listed: true,
    "listed-page": true,
    "active-label": active,
    "drop-target": isOver,
  });
  const topFolderClasses = cx({
    "listed-page-icon": true,
    glyphicon: true,
    "glyphicon-folder_closed": !active,
    "glyphicon-folder_open": active,
  });

  return (
    <div
      className={topClasses}
      onClick={onClick}
      title={name}
      ref={dropRef}
      style={{
        border: isOver ? "2px dashed var(--background-accent-primary)" : "none",
        backgroundColor: isOver
          ? "var(--background-hover-secondary)"
          : "transparent",
      }}
    >
      <span className={topFolderClasses} />
      <label>{name}</label>
      {active && enableContextMenu && (
        <span onClick={(e) => e.stopPropagation()}>
          <ContextMenuWrapper placement="bottom" icon="menuMoreHoriz">
            <MenuItem
              data-e2e={uiPrefix(`rename-folder-btn`)}
              onClick={onRename}
            >
              Rename
            </MenuItem>
            <MenuItem
              data-e2e={uiPrefix(`delete-folder-btn`)}
              onClick={onDelete}
            >
              Delete Folder
            </MenuItem>
          </ContextMenuWrapper>
        </span>
      )}
    </div>
  );
};

export default AssetFolder;
